import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import ChangeIpForm from '../forms/ChangeIpForm'
import PaymentInformation from './PaymentInformation'
import ChangeIpSubnetForm from '../forms/ChangeIpSubnetForm'
import CGNATOptOutForm from '../forms/CGNATOptOutForm'
import globals from '../globals'

class ChangeMyIp extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            ipv4: {
                currentIp: '',
                nextAvailableIp: ''
            },
            ipv6: {
                currentIp: '',
                nextAvailableIp: ''
            },
            ipv6Subnet: {
                currentSubnet: '',
                nextAvailableSubnet: ''
            },
            // CG-Nat form is only available if the customer has NOT already opted out and they are NOT already on a fixed IP (ie. legacy customers)
            canOptOutCGNAT: false
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getIpData/${this.props.type}/${this.props.serviceId}`, result => {
            this.setState(result)
            this.setState({ isLoaded: true })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        return (
            <div>
                <div className='change-ip module'>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2 text-center'>
                                <p>You can change your IP address or subnet here. We will confirm your IP address change via email. Once your address change is confirmed you should reboot your modem to ensure your new IP address is properly allocated.</p>
                            </div>
                        </div>
                        <div className='row mt-3 mb-5 mb-md-3'>
                            <div className='col-12 col-md-6 offset-md-3'>
                                <h4 className='mt-0'>Change IPv4 Address</h4>
                                <ChangeIpForm data={this.state.ipv4} serviceId={this.props.serviceId} type='IPv4' handleSuccess={() => globals.pushEvent('ChangeIpv4Submit')} />
                            </div>
                        </div>
                        <div className='row mt-3 mb-5 mb-md-3'>
                            <div className='col-12 col-md-6 offset-md-3'>
                                <h4 className='mt-0'>Change IPv6 Address</h4>
                                <ChangeIpForm data={this.state.ipv6} serviceId={this.props.serviceId} type='IPv6' handleSuccess={() => globals.pushEvent('ChangeIpv6Submit')} />
                            </div>
                        </div>
                        <div className='row mt-3 mb-5 mb-md-3'>
                            <div className='col-12 col-md-6 offset-md-3'>
                                <h4 className='mt-0'>Change IPv6 Subnet</h4>
                                <ChangeIpSubnetForm data={this.state.ipv6Subnet} serviceId={this.props.serviceId} handleSuccess={() => globals.pushEvent('ChangeIpv6SubmitSubnet')} />
                            </div>
                        </div>
                        {this.state.canOptOutCGNAT
                            ? <div className='row mt-3 mb-5 mb-md-3 cgnat-opt-out-form'>
                                <div className='col-12 col-md-6 offset-md-3'>
                                    <h4 className='mt-0'>Carrier Grade NAT opt-out request</h4>
                                    <CGNATOptOutForm serviceId={this.props.serviceId} handleSuccess={() => globals.pushEvent('CarrierGradeNatOptoutRequest')} />
                                </div>
                              </div>
                            : ''}
                    </ModuleWithLoader>
                </div>
            </div>
        )
    }
}

export default ChangeMyIp



// WEBPACK FOOTER //
// ./resources/js/modules/ChangeMyIp.js